import { Types } from './types';

export function tiposIndigenasRequest(token: string) {
	return {
		type: Types.TIPOS_INDIGENAS_REQUEST,
		token,
	};
}

export function tiposIndigenasSuccess(payload: object) {
	return {
		type: Types.TIPOS_INDIGENAS_SUCCESS,
		payload,
	};
}

export function tiposIndigenasFailure(payload: boolean) {
	return {
		type: Types.TIPOS_INDIGENAS_FAILURE,
		payload,
	};
}
